import { Tool } from "./appContext";
import { ObjectType } from "./objects";

/** マルチプレイ全体のキルスイッチ。false の間は UI 入口も ?room= 直リンクも機能しない。 */
export const MULTIPLAYER_ENABLED = false;

export const NODE_GATED_OBJECT_TYPES: readonly ObjectType[] = [
  "calc",
  "count",
  "display",
  "timer",
  "decay",
  "orbit",
  "group",
  "timbre",
  "pitchQuantize",
  "delay",
  "router",
  "button",
  "lamp",
  "knob",
  "envelope",
  "array",
  "curve",
  "global",
];

const NODE_GATED_OBJECT_TYPE_SET = new Set<ObjectType>(NODE_GATED_OBJECT_TYPES);

export function isNodeGatedObjectType(type: ObjectType): boolean {
  return NODE_GATED_OBJECT_TYPE_SET.has(type);
}

export const NODE_GATED_TOOLS: readonly Tool[] = [...NODE_GATED_OBJECT_TYPES];
const NODE_GATED_TOOL_SET = new Set<Tool>(NODE_GATED_TOOLS);

export function isNodeGatedTool(tool: Tool): boolean {
  return NODE_GATED_TOOL_SET.has(tool);
}
